import de from './de.json' with { type: 'json' };
import en from './en.json' with { type: 'json' };

export const billingI18nNamespace = 'billing' as const;
export const billingResources = { de, en } as const;
